export default __webpack_public_path__ + "static/media/td.93fa865b.svg";